._errorState_17l7f_1 {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  width: 352px;
  padding: 53px 24px 0; }

._image_17l7f_9 {
  margin-bottom: 35px; }

._title_17l7f_12, ._text_17l7f_12 {
  white-space: normal;
  text-align: center; }

._title_17l7f_12 {
  margin-bottom: 10px; }

._text_17l7f_12 {
  margin-bottom: 13px; }

._tryAgain_17l7f_22 {
  margin-bottom: 12px; }
